"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLLABORATOR_LIST_PAGE = exports.TEAM_LIST_LAYERED = exports.INIT_ROLE = exports.DELETE_ROLE_MEMBER = exports.ADD_ROLE_MEMBER = exports.GET_MEMBER_LIST_BY_ROLE = exports.UPDATE_ORG_ROLE = exports.DELETE_ORG_ROLE = exports.CREATE_NEW_ROLE = exports.GET_ROLE_LIST = exports.PROCESS_SPACE_JOIN = exports.SEARCH_UNIT_INFO_VO = exports.LOAD_OR_SEARCH = exports.MEMBER_UPDATE = exports.COLLABORATOR_INFO = exports.MEMBER_UNITS = exports.GET_SUB_UNIT_LIST = exports.SEARCH_UNIT = exports.MEMBER_SEARCH = exports.UPLOAD_MEMBER_FILE = exports.DOWNLOAD_MEMBER_FILE = exports.RESEND_INVITE = exports.SEND_INVITE = exports.EXIST_EMAIL = exports.GET_ADD_MEMBERS = exports.TEAM_ADD_MEMBER = exports.UPDATE_MEMBER_TEAM = exports.SEARCH_TEAM_MEMBER = exports.BATCH_DELETE_MEMBER = exports.SINGLE_DELETE_MEMBER = exports.UPDATE_MEMBER = exports.DELETE_TEAM = exports.READ_SUB_TEAMS = exports.TEAM_MEMBERS = exports.READ_TEAM = exports.CREATE_TEAM = exports.UPDATE_TEAM = exports.MEMBER_LIST_IN_SPACE = exports.MEMBER_INFO = exports.MEMBER_LIST = void 0;
// ================ Contacts related =======================
// Address Book - Query the member list of the specified department
exports.MEMBER_LIST = '/org/member/list';
// address book - get member details
exports.MEMBER_INFO = '/org/member/read';
// Space Station-Address Book Management-Member Management-Pagination to query the member list of the specified department
exports.MEMBER_LIST_IN_SPACE = '/org/member/page';
// Space station - address book management - member management - modify department information
exports.UPDATE_TEAM = '/org/team/update';
// Space station - address book management - member management - add sub-departments
exports.CREATE_TEAM = '/org/team/create';
// Space station - address book management - member management - query department information
exports.READ_TEAM = '/org/team/read';
// address book - query the members under the department
exports.TEAM_MEMBERS = '/org/team/members';
// Space station - address book management - member management - query the list of subordinate departments
exports.READ_SUB_TEAMS = '/org/team/subTeams';
// Space station - address book management - member management - delete department
exports.DELETE_TEAM = '/org/team/delete/';
// Space station - address book management - member management - edit member information
exports.UPDATE_MEMBER = '/org/member/updateInfo';
// Space station - address book management - member management - single delete member
exports.SINGLE_DELETE_MEMBER = '/org/member/delete';
// Space station - address book management - member management - batch delete members
exports.BATCH_DELETE_MEMBER = '/org/member/deleteBatch';
// Space station - address book management - member management - search department or member
exports.SEARCH_TEAM_MEMBER = '/org/search';
// Space station - address book management - member management - adjust the department to which members belong
exports.UPDATE_MEMBER_TEAM = '/org/member/updateMemberTeam';
// Space station - address book management - member management - department adding members
exports.TEAM_ADD_MEMBER = '/org/member/addMember';
// Space station - address book management -
// member management - search for organizational resources / search in the modal of adding department members
exports.GET_ADD_MEMBERS = '/org/search/unit';
// Space station - determine whether member mailboxes exist in the space
exports.EXIST_EMAIL = '/org/member/checkEmail';
// Space Station - Mail invites external members for the first time
exports.SEND_INVITE = '/org/member/sendInvite';
// space station-mail invites external members again
exports.RESEND_INVITE = '/org/member/sendInviteSingle';
// Space station - download employee information form template
exports.DOWNLOAD_MEMBER_FILE = '/org/member/downloadTemplate';
// space station - upload employee information form
exports.UPLOAD_MEMBER_FILE = '/org/member/uploadExcel';
// space station-sub-admin-fuzzy search member
exports.MEMBER_SEARCH = '/org/member/search';
// search for org resources
exports.SEARCH_UNIT = '/org/searchUnit';
// Query the sub-departments and members under the department
exports.GET_SUB_UNIT_LIST = '/org/getSubUnitList';
// Query the list of organizational units that belong to the space
exports.MEMBER_UNITS = '/org/member/units';
exports.COLLABORATOR_INFO = 'node/collaborator/info';
/**
 * Edit Member Info
 */
exports.MEMBER_UPDATE = '/org/member/update';
// load or search for members
exports.LOAD_OR_SEARCH = '/org/loadOrSearch';
// Accurately find user information based on the provided name
exports.SEARCH_UNIT_INFO_VO = 'org/searchUnitInfoVo';
// handle the "someone joined the space station" message
exports.PROCESS_SPACE_JOIN = '/space/apply/process';
// ================ Contacts related =======================
// ============ Character related start =====================//
exports.GET_ROLE_LIST = '/org/roles';
exports.CREATE_NEW_ROLE = '/org/roles';
exports.DELETE_ORG_ROLE = '/org/roles/:roleId';
exports.UPDATE_ORG_ROLE = '/org/roles/:roleId';
exports.GET_MEMBER_LIST_BY_ROLE = '/org/roles/:roleId/members';
exports.ADD_ROLE_MEMBER = '/org/roles/:roleId/members';
exports.DELETE_ROLE_MEMBER = '/org/roles/:roleId/members';
exports.INIT_ROLE = '/org/roles/init';
exports.TEAM_LIST_LAYERED = 'org/team/tree';
exports.COLLABORATOR_LIST_PAGE = '/node/collaborator/page';
//# sourceMappingURL=url.org.js.map